import axios from "axios";
const axiosInstance = axios.create({});

axiosInstance.interceptors.response.use(
  (res: any) => res,
  (err: any) => {
    if (err.response?.data?.includes("token")) {
      let errData = {
        errors: [{ errorMessage: "Invalid token" }],
      };
      err.response = errData;
    }
    throw err;
  }
);

export default axiosInstance;
